module.exports = __webpack_public_path__ + "static/CC-logo-full-stacked-c852a5beb3aeff8e38e31f3f630afc6e.jpg";